import * as Yup from 'yup';

/**
 * The one definition of what makes an acceptable KBT password.
 *
 * These rules were copy-pasted between EmailSignUpModal (SignupSchema) and
 * InviteRedemptionModal (AccountSchema). Both now import from here, so a
 * change to the policy lands in one place and cannot drift.
 *
 * The wording of each message is preserved exactly as it was, since it is
 * what members already see under the field.
 */
export const passwordRules = Yup.string()
  .min(8, 'Min 8 characters')
  .matches(/[A-Z]/, 'Need uppercase letter')
  .matches(/[a-z]/, 'Need lowercase letter')
  .matches(/[0-9]/, 'Need number')
  .matches(/[^A-Za-z0-9]/, 'Need special character')
  .required('Required');

/**
 * Confirmation field. Expects a sibling field literally named `password`.
 *
 * That name is load-bearing and fails silently. `Yup.ref('password')`
 * resolves to `undefined` against a schema whose field is named anything
 * else — say `newPassword` — and the confirm field then rejects EVERY
 * value with "Passwords must match", including the correct one. No
 * exception, no warning; just a field nobody can get past. Rename the
 * sibling to `password` rather than reaching for `Yup.ref` here.
 */
export const confirmPasswordRules = Yup.string()
  .oneOf([Yup.ref('password')], 'Passwords must match')
  .required('Required');
